import { CANDYRACK_OFFSET_VALUE } from '../shared/constants/app';
import customLocalStorage from '../shared/product-page-placement/storage';

const toggleBodyStyle = (popUpOpened: Boolean) => {
  const body = document.querySelector('body');
  if (!body) {
    return;
  }
  if (popUpOpened) {
    const height = window.pageYOffset.toString();
    customLocalStorage.setItem(CANDYRACK_OFFSET_VALUE, height);

    body.classList.toggle('candyrack-body-open');
    body.style.top = `-${height}px`;
  } else {
    const pageYOffset = customLocalStorage.getItem(CANDYRACK_OFFSET_VALUE);
    customLocalStorage.removeItem(CANDYRACK_OFFSET_VALUE);

    body.style.removeProperty('top');
    body.classList.toggle('candyrack-body-open');

    window.scrollBy(0, Number(pageYOffset));
  }
};

export default toggleBodyStyle;
